import React, { useEffect, useState, useRef } from 'react';
import { ArrowRight, LinkedinLogo } from '@phosphor-icons/react';
export function CTASection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      });
    }, {
      threshold: 0.08,
      rootMargin: '0px 0px -40px 0px'
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return <section ref={sectionRef} className="bg-black text-white py-24 sm:py-32 md:py-40 px-6 sm:px-12 md:px-16 lg:px-24 overflow-hidden" style={{
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? 'translateY(0)' : 'translateY(40px)',
    transition: 'opacity 0.8s ease-out, transform 0.8s ease-out'
  }} data-id="element-1519">
      <div className="container mx-auto max-w-7xl" data-id="element-1520">
        <div className="max-w-4xl" data-id="element-1521">
          {/* Oversized Type */}
          <div className="text-xs tracking-[0.3em] uppercase text-white/50 mb-6 font-medium" style={{
          fontFamily: "'Ronzino', sans-serif"
        }} data-id="element-1522">
            LET'S WORK TOGETHER
          </div>
          <h2 className="text-4xl sm:text-6xl md:text-7xl lg:text-8xl leading-[1] tracking-tight font-light" style={{
          fontFamily: "'Gefika', sans-serif"
        }} data-id="element-1523">
            Have a Project?
          </h2>
          <div className="w-24 h-px bg-white/30 mt-12 mb-12" data-id="element-1524"></div>

          {/* CTAs side by side under the heading */}
          <div className="flex flex-col sm:flex-row gap-4" data-id="element-1525">
            <a href="https://calendly.com/mateo-cohen9/15min" target="_blank" rel="noopener noreferrer" className="flex-1 flex items-center justify-between bg-white text-black px-8 py-5 rounded-full text-sm font-medium uppercase tracking-[0.15em] hover:bg-slate-200 transition-colors group" style={{
            fontFamily: "'Ronzino', sans-serif"
          }} data-id="element-1526">
              <span data-id="element-1527">Book a Call</span>
              <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-1528" />
            </a>

            <a href="https://www.linkedin.com/in/mateo-aistrategist/" target="_blank" rel="noopener noreferrer" className="flex-1 flex items-center justify-between bg-transparent border border-white/20 text-white px-8 py-5 rounded-full text-sm font-medium uppercase tracking-[0.15em] hover:bg-white/10 transition-colors group" style={{
            fontFamily: "'Ronzino', sans-serif"
          }} data-id="element-1529">
              <div className="flex items-center gap-3" data-id="element-1530">
                <LinkedinLogo className="w-5 h-5" weight="fill" data-id="element-1531" />
                <span data-id="element-1532">Contact Me</span>
              </div>
              <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-1533" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}